import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {usePageProps} from 'context/pageProps'
import {
  getCurrencyCode,
  getLanguageCode,
  getLocalizationIsInitialized
} from 'modules/meta/selectors'
import {
  initializeLocalizationConfig,
  setAnalyticsPageName
} from 'modules/meta/slice'
import {persistLanguageCode} from 'utils/localization/language'
import {persistCurrencyCode} from 'utils/localization/persistCurrencyCode'

const InitializeMeta = ({children}) => {
  const dispatch = useDispatch()
  const languageCode = useSelector(getLanguageCode)
  const currencyCode = useSelector(getCurrencyCode)
  const localizationIsInitialized = useSelector(getLocalizationIsInitialized)
  const {page} = usePageProps()

  useEffect(() => {
    dispatch(setAnalyticsPageName({page}))
  }, [page])

  useEffect(() => {
    if (!localizationIsInitialized) dispatch(initializeLocalizationConfig())
  }, [dispatch, localizationIsInitialized])

  useEffect(() => {
    persistLanguageCode(languageCode)
  }, [languageCode])

  useEffect(() => {
    persistCurrencyCode(currencyCode)
  }, [currencyCode])

  return children
}

export default InitializeMeta
